module.exports = __webpack_public_path__ + "b0a4f5bbad73483f01fdcf707c70027e.pdf";